<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="addRecordDialog.title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    @close="closeDialog"
  >
    <div class="form">
      <el-form
        ref="form"
        :model="form"
        :rules="form_rules"
        :label-width="dialog.formLabelWidth"
        style="margin: 10px; width: auto"
      >
        <el-form-item prop="coursePerformance" label="主教练评价">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入主教练评价"
            v-model="form.coursePerformance"
          ></el-input>
        </el-form-item>

        <el-form-item prop="assRate1" label="助教评价">
          <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入助教评价"
                  v-model="form.assRate1"
          ></el-input>
        </el-form-item>

        <el-form-item prop="assRate2" label="助教评价">
          <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入助教评价"
                  v-model="form.assRate2"
          ></el-input>
        </el-form-item>

        <el-form-item prop="remark" label="备注">
          <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入备注"
                  v-model="form.remark"
          ></el-input>
        </el-form-item>

<!--        <el-form-item prop="recordNote" label="课堂备注">-->
<!--          <el-input-->
<!--            type="textarea"-->
<!--            :rows="2"-->
<!--            placeholder="请输入事件备注"-->
<!--            v-model="form.recordNote"-->
<!--          ></el-input>-->
<!--        </el-form-item>-->

<!--        <el-form-item prop="courseContent" label="学习内容">-->
<!--          <el-input-->
<!--            type="textarea"-->
<!--            :rows="2"-->
<!--            placeholder="请输入学习内容"-->
<!--            v-model="form.courseContent"-->
<!--          ></el-input>-->
<!--        </el-form-item>-->

        <el-form-item class="text_right">
          <el-button @click="isVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";

import { updateRecord } from "@/api/record";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  name: "addFundDialogs",
  data() {
    return {
      isVisible: this.isShow,
      form: {
        id: "",
        coursePerformance: "",
        assRate1: "",
        assRate2: "",
        remark: "",
        recordNote: "",
        courseContent:""
      },
      courseDate: "",
      courseTime: "",
      courseLocation: "",
      form_rules: {},
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
    };
  },
  props: {
    isShow: Boolean,
    dialogRow: Object,
    stdname: String,
    courseType: String,
  },
  computed: {
    ...mapGetters(["addRecordDialog"]),
  },
  created() {},
  mounted() {
    if (this.addRecordDialog.type === "edit") {
      this.form = this.dialogRow;
      console.log(this.dialogRow);
      this.courseDate = this.dialogRow.courseDate;
      this.courseTime = this.dialogRow.courseTime;
      this.courseLocation = this.dialogRow.courseLocation;
    } else {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    //表单提交
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let formData = this[form];
          const para = Object.assign({}, formData);
          let courseDate = this.courseDate;
          let courseTime = this.courseTime;
          let courseLocation = this.courseLocation;
          let courseType = this.courseType;
          // edit
          if (this.addRecordDialog.type === "edit") {
            updateRecord(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content:
                    "修改学员(" +
                    this.stdname +
                    ")记录操作" +
                    courseDate +
                    ",时间:" +
                    courseTime +
                    ",地点:" +
                    courseLocation +
                    ",班级类型:" +
                    courseType,
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.isVisible = false;
                this.$emit("getRecordList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          } else {
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
